import React from "react";
import { GenderValue } from "shared";
import { makeStyles } from "@mui/styles";
import { PatientColorMap } from "../../layout/patientColorMap";
import { useTranslate } from "../../hooks/useTranslate";
import { useNavigation } from "../../state/navigationContext";
import GenderIcon from "fe-web-components/genderIcon/GenderIcon";

//region [[ Styles ]]
const useStyles = makeStyles({
  wrapper: {
    backgroundColor: (props: ResultHeaderProps) => {
      return props.isSummary ? "white" : PatientColorMap.Header;
    },
    borderRadius: "0 0 0 80px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 0",
    paddingTop: (props: ResultHeaderProps) =>
      props.isLocaleChangerFlagActive ? "66px" : "24px",
  },
  avatar: {
    height: "54px",
    width: "54px",
  },
  headerText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    margin: "8px",
    padding: "8px",
    color: PatientColorMap.Primary,
    fontSize: "18px",
    lineHeight: "20px",
    overflow: "unset",
  },
  name: {
    fontSize: "20x",
    fontWeight: "bold",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]
export interface ResultHeaderProps {
  isSummary?: boolean;
  age: string;
  gender: GenderValue;
  isLocaleChangerFlagActive: boolean;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const ResultHeader = ({ ...props }: ResultHeaderProps) => {
  const classes = useStyles(props);

  const { age, gender } = props;

  const { translate } = useTranslate();

  const GENDER_MALE = "MALE";

  const GENDER_FEMALE = "FEMALE";

  const genderText = translate(
    gender === GenderValue.MALE
      ? GENDER_MALE
      : gender === GenderValue.FEMALE
      ? GENDER_FEMALE
      : "",
  );

  const ageText = parseInt(age) ? `, ${age}` : "";

  const { themeSettings } = useNavigation();

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <GenderIcon big gender={gender} themeSettings={themeSettings} />
        <div className={classes.headerText}>
          {(ageText !== "" || genderText !== "") && (
            <div> {`${genderText}${ageText}`}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultHeader;
